export default __webpack_public_path__ + "static/media/1.64a9de4b.webp";